// extracted by mini-css-extract-plugin
export default {"searchContainer":"SearchInput_searchContainer__V8-P4","filterIcon":"SearchInput_filterIcon__OHpuQ"};